import { call, put, takeEvery } from "redux-saga/effects";
import { GET_FAQ_FAILED, GET_FAQ_REQUESTED, GET_FAQ_SECTION_FAILED, GET_FAQ_SECTION_REQUESTED, GET_FAQ_SECTION_SUCCESS, GET_FAQ_SUCCESS} from "resources/actionTypes";
import {faqApi, faqSectionApi } from "services/FAQService";

function* fetchFaq(action) {
  try {
    const payload = action.payload || {}
    const userFaq = yield call(faqApi,payload);
    yield put({ type: GET_FAQ_SUCCESS, userFaq: userFaq });
  } catch (e) {
    yield put({ type: GET_FAQ_FAILED, message: e.message });
  }
}

export function* faqSaga() {
  yield takeEvery(GET_FAQ_REQUESTED, fetchFaq);
}
function* fetchFaqSection(action){
    try{
        const payload = action.payload || {}
        const userFaqSection = yield call(faqSectionApi,payload);
        yield put ({ type:GET_FAQ_SECTION_SUCCESS,userFaqSection:userFaqSection});
    } catch (e) {
        yield put ({ type:GET_FAQ_SECTION_FAILED,message:e.message });
    }
}
export function* faqSectionSaga(){
    yield takeEvery(GET_FAQ_SECTION_REQUESTED,fetchFaqSection)
}